import React from 'react';
import css from './HeroSectionScanwow.module.css';
import TopbarDynamicSearch from '../../../TopbarContainer/Topbar/TopbarDynamicSearch/TopbarDynamicSearch';
import { useHistory } from 'react-router-dom';
import whyImg2 from './why2.jpg';
import whyImg3 from './why3.jpg';

export const TypingText = ({ text }) => {
  const word = text || 'Connect.';
  const [displayed, setDisplayed] = React.useState('');
  const [typing, setTyping] = React.useState(true);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    let timeout;
    if (typing) {
      if (index < word.length) {
        timeout = setTimeout(() => {
          setDisplayed(word.slice(0, index + 1));
          setIndex(index + 1);
        }, 120);
      } else {
        timeout = setTimeout(() => setTyping(false), 900);
      }
    } else {
      if (index > 0) {
        timeout = setTimeout(() => {
          setDisplayed(word.slice(0, index - 1));
          setIndex(index - 1);
        }, 120);
      } else {
        timeout = setTimeout(() => setTyping(true), 400);
      }
    }
    return () => clearTimeout(timeout);
  }, [typing, index, word]);

  return (
    <span>
      {displayed}
      <span className={css.caret}></span>
    </span>
  );
};

const HeroSectionScanwow = () => {
  const history = useHistory();
  const quickActionButtons = [
    {
      label: 'Gaussian Splat',
      to: '/s?pub_scanType=gaussianSplat',
    },
    {
      label: 'Point Cloud',
      to: '/s?pub_scanType=pointCloud',
    },
    {
      label: 'Mesh Assets',
      to: '/s?pub_scanType=mesh',
    },
    {
      label: 'Voxel Assets',
      to: '/s?pub_scanType=voxel',
    },
  ];
  return (
    <div className={css.wrapper}>
      <div className={css.contentWrapper}>
        <p className={css.title}>
          Capture. Create. <TypingText />
        </p>
        <p className={css.subtitle}>
          Explore the edge of what's possible with real-world 3d assets.
        </p>
        <TopbarDynamicSearch />
        <div className={css.qaButtonsWrapper}>
          {quickActionButtons.map((b) => (
            <button
              key={b.label}
              type="button"
              onClick={() => history.push(b.to)}
              className={css.quickActionButton}
            >
              <b className={css.searchIcon}></b>
              <span>{b.label}</span>
            </button>
          ))}
        </div>

        <div className={css.sectionWhyWrapper}>
          <div className={css.sectionWhyLeft}>
            <a href="/s" className={css.justText}>
              Just added assets!
            </a>
            <p className={css.whyTitle}>
              Scanwow is your launchpad for exploring and sharing 3d assets. Built by makers, for
              makers
            </p>
            <p className={css.whySubtitle}>
              From our first scan to a growing creative community—read about how Scanwow came to be
              and what’s next.
            </p>
            <button
              type="button"
              className={css.whyButton}
              onClick={() => history.push('/about-us')}
            >
              <span>Why We Do What We Do</span>
            </button>
          </div>

          <div className={css.sectionWhyRight}>
            <img src={whyImg2} alt="Scanwow Hero Why" className={css.sectionWhyImage1} />

            <img src={whyImg3} alt="Scanwow Hero Why" className={css.sectionWhyImage2} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionScanwow;
